import { Flex, Typography, theme } from 'antd';
import LivePulseDot from './LivePulseDot';

const { Text } = Typography;

const LiveStatus = () => {
  const { token } = theme.useToken();

  return (
    <Flex align="center" gap={8} style={{ flexShrink: 0 }}>
      <LivePulseDot color={token.orange8} size={9} />
      <Text
        style={{
          fontSize: token.fontSizeSM,
          fontWeight: token.fontWeightStrong,
          letterSpacing: '0.06em',
          color: token.orange8,
          textTransform: 'uppercase',
        }}
      >
        Live
      </Text>
    </Flex>
  );
};

export default LiveStatus;
